import type { ReactNode } from 'react';
import { Icon } from '@shared/ui/icon/Icon';

export interface ErrorStateProps {
  title?: string;
  message: string;
  action?: ReactNode;
}

/** État d'erreur sobre, avec action de reprise éventuelle. */
export function ErrorState({
  title = 'Une erreur est survenue',
  message,
  action,
}: ErrorStateProps) {
  return (
    <div
      role="alert"
      className="flex flex-col items-center justify-center gap-3 rounded-lg border border-red-200 bg-red-50 px-6 py-12 text-center"
    >
      <span className="flex size-11 items-center justify-center rounded-full bg-red-100 text-red-600">
        <Icon name="alert" size={22} />
      </span>
      <p className="text-sm font-semibold text-red-800">{title}</p>
      <p className="max-w-sm text-sm text-red-600">{message}</p>
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
